var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.948244 0H17.0512C17.5732 0 18.0002 0.427 18.0002 0.949V1.051C18.0002 1.573 17.5732 2 17.0512 2H0.948244C0.426244 2 0.000244141 1.573 0.000244141 1.051V0.949C0.000244141 0.427 0.426244 0 0.948244 0ZM17.0512 5H0.948244C0.426244 5 0.000244141 5.427 0.000244141 5.949V6.051C0.000244141 6.573 0.426244 7 0.948244 7H17.0512C17.5732 7 18.0002 6.573 18.0002 6.051V5.949C18.0002 5.427 17.5732 5 17.0512 5ZM17.0512 10H0.948244C0.426244 10 0.000244141 10.427 0.000244141 10.949V11.051C0.000244141 11.573 0.426244 12 0.948244 12H17.0512C17.5732 12 18.0002 11.573 18.0002 11.051V10.949C18.0002 10.427 17.5732 10 17.0512 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/BurgerMenu.ca160fa106b27d55565eb3db614aee17.svg";
export { ForwardRef as ReactComponent };